import { history } from '../../Configs/history/history';
import { AppRoutes } from '../../Core/App/AppRoutes';
import { INavigationService } from '../../Core/Services/Interfaces/INavigationService';

//* Generic detail route
const getDetailsRoute = (id: string, detailsRoute: string): string =>
    `${detailsRoute}`.replace(':id', id);

export class NavigationService implements INavigationService {
    getHomeLink = AppRoutes.HOME;

    goTo = (route: string, replace?: boolean): void => {
        if (replace) {
            history.replace(route);
        } else {
            history.push(route);
        }
    };
    goToHome = (): void => history.push(AppRoutes.HOME);
    goToLogin = (): void => history.push(AppRoutes.LOGIN);
    goToForgotPassword = (): void => history.push(AppRoutes.PASSWORD_FORGOT);
    goToResetPassword = (): void => history.push(AppRoutes.PASSWORD_RESET);

    getAffaireDetails = (affaireId: string): string =>
        getDetailsRoute(affaireId, AppRoutes.AFFAIRE_DETAILS);

    //* Controle Templates
    getControleTemplateCreate = AppRoutes.CONTROLE_LIST;
    getControleTemplateDetail = (id: string) => getDetailsRoute(id, AppRoutes.CONTROLE_DETAILS);

    goToControleTemplateDetail = (id: string, replace: boolean): void =>
        this.goTo(getDetailsRoute(id, AppRoutes.CONTROLE_DETAILS), replace);

    goToAffaireDetails = (affaireId: string): void =>
        history.push(getDetailsRoute(affaireId, AppRoutes.AFFAIRE_DETAILS));
    goToAffaireCreate = (): void => history.push(AppRoutes.AFFAIRE_CREATE);

    getCompagnonDetails = (compagnonId: string) =>
        getDetailsRoute(compagnonId, AppRoutes.COMPAGNON_DETAILS);
    goToCompagnonCreate = () => history.push(AppRoutes.COMPAGNON_CREATE);
    goToCompagnonDetails = (compagnonId: string) =>
        history.push(getDetailsRoute(compagnonId, AppRoutes.COMPAGNON_DETAILS));

    goToRH = () => history.push(AppRoutes.RH);
    goToRHFormations = () => history.push(AppRoutes.RH_FORMATIONS);
    goToRHAbsences = () => history.push(AppRoutes.RH_ABSENCES);
    goToRHVisitesMedicales = () => history.push(AppRoutes.RH_VISITES_MEDICALES);

    getEnginDetails = (enginId: string) => getDetailsRoute(enginId, AppRoutes.ENGIN_DETAILS);
    goToEnginCreate = () => history.push(AppRoutes.ENGIN_CREATE);
    goToEnginDetails = (enginId: string) =>
        history.push(getDetailsRoute(enginId, AppRoutes.ENGIN_DETAILS));

    getMaterielDetails = (materielId: string) =>
        getDetailsRoute(materielId, AppRoutes.MATERIEL_DETAILS);
    goToMaterielCreate = () => history.push(AppRoutes.MATERIEL_CREATE);
    goToMaterielDetails = (materielId: string) =>
        history.push(getDetailsRoute(materielId, AppRoutes.MATERIEL_DETAILS));

    getVehiculeDetails = (vehiculeId: string) =>
        getDetailsRoute(vehiculeId, AppRoutes.VEHICULE_DETAILS);
    goToVehiculeCreate = () => history.push(AppRoutes.VEHICULE_CREATE);
    goToVehiculeDetails = (vehiculeId: string) =>
        history.push(getDetailsRoute(vehiculeId, AppRoutes.VEHICULE_DETAILS));

    getCauserieDetails = (causerieId: string) =>
        getDetailsRoute(causerieId, AppRoutes.CAUSERIE_DETAILS);

    goToCauserieCreate = () => history.push(AppRoutes.CAUSERIE_CREATE);
    goToCauserieList = () => history.push(AppRoutes.CAUSERIE_LIST);
    goToCauserieDetails = (causerieId: string) =>
        history.push(getDetailsRoute(causerieId, AppRoutes.CAUSERIE_DETAILS));

    getClientDetails = (clientId: string) => getDetailsRoute(clientId, AppRoutes.CLIENT_DETAILS);
    goToClientCreate = () => history.push(AppRoutes.CLIENT_CREATE);
    goToClientDetails = (clientId: string) =>
        history.push(getDetailsRoute(clientId, AppRoutes.CLIENT_DETAILS));
}
